import { Component, Input, OnInit } from '@angular/core';
import { ProductServiceResponse } from './meatball-menu.model';
import { TooltipPosition } from '@angular/material/tooltip';
import { MeatballMenuService } from './meatball-menu.service';
import {URL_GELDOVER} from "./meatball-menu.constants";

@Component({
  selector: 'app-meatball-menu',
  templateUrl: './meatball-menu.component.html',
  styleUrls: ['./meatball-menu.component.css'],
})
export class MeatBallMenuComponent implements OnInit {
  @Input()
  public title: string;
  @Input()
  productServiceList: ProductServiceResponse;
  @Input()
  otherLinks: [];
  @Input()
  hasBOCockpit: boolean;
  @Input()
  hasMijnWonen: boolean;
  @Input()
  hasGeldOver: boolean;

  toolTipPosition: TooltipPosition = 'above';
  listSize = 0;

  constructor(private readonly meatBallMenuService: MeatballMenuService) { }

  ngOnInit() {
    if (this.productServiceList.product === null) {
      this.listSize = 0;
    } else {
      this.listSize = this.productServiceList.product.services.length || 0;
    }
  }

  openCockpit() {
    this.meatBallMenuService.getCockPitUrl();
  }

  openMijnWonen() {
    this.meatBallMenuService.getWonenPortaalURL().subscribe(
      (res: any) => {
        if (res.listOfError && res.listOfError.length) {
          return;
        }
        if(res.wonenPortaalURL !== null) {
          const redirectUrl = res.wonenPortaalURL;
          window.open(redirectUrl, '_blank');
        }
      },
      (error) => { },
    );
  }

  openGeldOverPortaal() {
    this.meatBallMenuService.getGeldOverPortalURL().subscribe(
      (res: any) => {
        if (res.listOfError && res.listOfError.length) {
          return;
        }
        window.open(URL_GELDOVER + res.relationId, '_blank');
      },
      () => { },
    );
  }
}
